"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CapacidadeChaveModelo = void 0;
var bson_1 = require("bson");
var CapacidadeChaveModelo = /** @class */ (function () {
    function CapacidadeChaveModelo(_a) {
        var _b = _a._id, _id = _b === void 0 ? new bson_1.ObjectId() : _b, _c = _a.DT_VAL_INI, DT_VAL_INI = _c === void 0 ? '' : _c, _d = _a.DT_VAL_FIM, DT_VAL_FIM = _d === void 0 ? '' : _d, _e = _a.chaveModelo, chaveModelo = _e === void 0 ? '' : _e, _f = _a.capacidadeAcumulada, capacidadeAcumulada = _f === void 0 ? 0 : _f;
        this._id = _id;
        this.DT_VAL_INI = DT_VAL_INI;
        this.DT_VAL_FIM = DT_VAL_FIM;
        this.chaveModelo = chaveModelo;
        this.capacidadeAcumulada = capacidadeAcumulada;
    }
    return CapacidadeChaveModelo;
}());
exports.CapacidadeChaveModelo = CapacidadeChaveModelo;
//# sourceMappingURL=CapacidadeChaveModelo.js.map